import React from "react";
import leftPng from "../../../../../content/images/left.png";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import NumberFormat from "react-number-format";
import {wait} from "@testing-library/react";

class Bewerkprijsperuitvoerder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableArray: [],
            constTableArray: [],
            uitvoerder: "",
            procentueel: "",
            nieuwbedrag: "",
            vastbedrag: "",
            uitvoerderSelect: [],
            createState: false,
            createButtonState: false,
            editButtonState: false,
            uitvoerderText: "",
            uitvoerderId: "",
            activeIndexId: "",
            activeIndex: false,
            activityIdentification: "",
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
    }

    trCount = 1;

    handleEvent() {
        // this.state = {
        //   tableArray: this.state.tableArray,
        //   uitvoerder: this.state.uitvoerder,
        //   procentueel: this.state.procentueel,
        //   nieuwbedrag: this.state.nieuwbedrag,
        //   uitvoerderSelect: this.state.uitvoerderSelect,
        // };
    }

    /**
     * * girilen değerler anlık olarak çekilir.
     * @param {element hareketlerini getirir.} event
     * @constant {sadece rakam kabul edilir. } const re = /^[0-9\b]+$/;
     */
    handleInputChange = (event) => {
        const re = /^[0-9\b]+$/;
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (
            event.target.value === "" ||
            re.test(event.target.value) ||
            name == "uitvoerder"
        ) {
            this.setState({
                [name]: value,
            });

            if (name == "uitvoerder") {
                var index = event.nativeEvent.target.selectedIndex;
                this.setState({uitvoerderText: event.nativeEvent.target[index].text});
            }
        }
    };

    async handleSubmit() {
        var _continue = true;
        $("#cover-spin").show(0);
        var selectedIds = [];
        $("#example")
            .dataTable()
            .$("tr.selected")
            .each(function () {
                selectedIds.push($(this).attr("rowId"));
            });
        /**
         * * 1. ilk önce tüm verileri sil
         * * 2. sonra tüm verileri kaydet.
         */

        /**
         * * 1.adım
         */
        var model = [];
        var totalBaseCount =
            this.state.constTableArray !== undefined
                ? this.state.constTableArray.length
                : 1;

        if (this.state.constTableArray) {
            await this.state.constTableArray.forEach(async (item, index) => {
                await model.push({
                    op: "remove",
                    path: `/content/algemeen/prijsperuitvoerder/${--totalBaseCount}`,
                });
            });
            if (model.length > 0) {
                let result = await omnimap.PatchMethodAction(
                    model,
                    selectedIds[0],
                    false,
                    window.$catalog_management_units_token
                );
                if (result.result.status === "OK") {
                    _continue = true;
                } else {
                    _continue = false;
                    alert("error");
                }
            }
        }

        /**
         * * 2. adım
         */
        var modelCreate = [
            {
                op: "add",
                path: "/content/algemeen/prijsperuitvoerder",
                value: [],
            },
        ];
        await this.state.tableArray.forEach(async (element, index) => {
            await modelCreate[0].value.push({
                uitvoerder: {
                    display: [
                        {
                            path: "$.name",
                            value: element.uitvoerder.display[0].value,
                        },
                    ],
                    identification: element.uitvoerder.identification,
                },
                vastbedrag: Number(element.vastbedrag),
                nieuwbedrag: Number(element.nieuwbedrag),
                procentueel: Number(element.procentueel),
            });
        });
        if (modelCreate.length > 0 && _continue) {
            let result = await omnimap.PatchMethodAction(
                modelCreate,
                selectedIds[0],
                false,
                window.$catalog_management_units_token
            );
            if (result.result.status === "OK") {
                _continue = true;
            } else {
                alert("error");
                this.setState({tableArray: this.state.constTableArray});
            }
        }

        $("#cover-spin").hide(0);
    }

    async GetDetail(params) {
        $("#cover-spin").show(0);
        var selectedIds = [];
        $("#example")
            .dataTable()
            .$("tr.selected")
            .each(function () {
                selectedIds.push($(this).attr("rowId"));
            });

        /**
         * * new version
         */
        let result = await omnimap.GetRowOfDetailAction(
            selectedIds,
            window.$catalog_management_units_token
        );

        /**
         * * tekrar eden idleri burada buluyoruz
         */
        let lastEl = null;
        const swapArray = [];

        var array =
            result.data.content.algemeen.prijsperuitvoerder !== undefined
                ? result.data.content.algemeen.prijsperuitvoerder
                : [];
        array.forEach((el) => {
            if (el.uitvoerder.identification !== null) {
                swapArray.push(el.uitvoerder.identification);
            }
        });

        swapArray.forEach((el, index) => {
            if (index > 0) {
                lastEl = swapArray[index - 1];
            }
            if (lastEl !== null && el === lastEl) {
                array[index].uitvoerder.identification = GC.uuidv4();
            }
        });

        this.setState({
            tableArray: array /*result.data.content.algemeen.prijsperuitvoerder*/,
            constTableArray: result.data.content.algemeen.prijsperuitvoerder,
        });
        /**
         * * old version
         */

            // var model = { definitions: [process.env.REACT_APP_UITVOERDER] };
        var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                    {
                        key: "algemeen-isuitvoerder",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_USER_ORGANISATION],
                sorting: [{sort_type: "text_score", direction: "DESCENDING"}],
            };
        var selectResult = await omnimap.FillTableAction(
            model,
            1,
            window.$catalog_management_units_token
        );
        this.setState({
            uitvoerderSelect: selectResult.data,
            uitvoerder: selectResult.data[0].identification,
            uitvoerderText: selectResult.data[0].name,
        });
        $("#cover-spin").hide(0);
    }

    addUitTable() {
        this.setState({
            createState: !this.state.createState,
            createButtonState: !this.state.createButtonState,
            procentueel: "",
            nieuwbedrag: "",
            vastbedrag: "",
        });
    }

    backTable() {
        this.setState({
            createState: !this.state.createState,
            createButtonState: false,
            editButtonState: false,
        });
    }

    async addUit() {
        var model = {
            uitvoerder: {
                display: [
                    {
                        path: "$.name",
                        value: this.state.uitvoerderText,
                    },
                ],
                identification: GC.uuidv4(),
            },
            vastbedrag: this.state.vastbedrag,
            nieuwbedrag: this.state.nieuwbedrag,
            procentueel: this.state.procentueel,
            sort: this.state.activeIndex ? this.state.activeIndexId : this.trCount++,
        };

        // Create a new array based on current state:
        let newList = [...this.state.tableArray];

        // Add item to it
        newList.push(model);

        // Set state
        await this.setState({
            tableArray: newList,
            createState: false,
            createButtonState: false,
        });
    }

    editUit(rowId) {
        const stage = this.state.tableArray.filter(
            (row) => row.uitvoerder.identification === rowId
        )[0];
        this.setState({
            uitvoerder: stage.uitvoerder.identification,
            uitvoerderText: stage.uitvoerder.display[0].value,
            procentueel: stage.procentueel,
            nieuwbedrag: stage.nieuwbedrag,
            vastbedrag: stage.vastbedrag,
            createState: true,
            createButtonState: false,
            editButtonState: true,
            activeIndexId: rowId,
        });
    }

    async editUitSave() {
        await this.remove(this.state.activeIndexId);
        await this.setState({activeIndex: true});
        await this.addUit();
        await this.setState({activeIndex: false, editButtonState: false});
    }

    remove(rowId) {
        // Array.prototype.filter returns new array
        // so we aren't mutating state here
        const arrayCopy = this.state.tableArray.filter(
            (row) => row.uitvoerder.identification !== rowId
        );
        this.setState({tableArray: arrayCopy});
        // this.setState({ data: arrayCopy });
    }

    filterList(e) {
        if (e.target.value === "") {
            this.setState({tableArray: this.state.constTableArray});
        } else {
            const arrayCopy = this.state.constTableArray.filter((row) =>
                row.uitvoerder.display[0].value
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            );
            this.setState({tableArray: arrayCopy});
        }
    }

    componentDidMount() {
        var that = this;
        $("#werkplan_bewerk_prijs_per_uitvoerder").on(
            "show.bs.modal",
            function (event) {
                that.GetDetail();
            }
        );
    }

    render() {
        this.handleEvent();
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="werkplan_bewerk_prijs_per_uitvoerder"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Prijs per uitvoerder</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <input
                                type="search"
                                className="modal-search"
                                onChange={this.filterList.bind(this)}
                                placeholder=""
                            />
                            <div className="modal-scroll">
                                <table
                                    class="table table-striped"
                                    hidden={!!this.state.createState}
                                >
                                    <thead>
                                    <tr>
                                        <th scope="col">Uitvoerder</th>
                                        <th scope="col">Procentueel</th>
                                        <th scope="col">Vast bedrag</th>
                                        <th scope="col">Nieuw bedrag</th>
                                        <th scope="col" class="text-right">
                                            <a
                                                href="javascript:void(0)"
                                                className="addStageList"
                                                onClick={this.addUitTable.bind(this)}
                                            />
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.tableArray.lenght? this.state.tableArray
                                        .sort(
                                            ({sort: previousID}, {sort: currentID}) =>
                                                previousID - currentID
                                        )
                                        .map((row) => (
                                            <tr id={row.uitvoerder.identification}>
                                                <td>{row.uitvoerder.display[0].value}</td>
                                                <td>{row.procentueel}</td>
                                                <td>
                                                    <NumberFormat
                                                        value={row.vastbedrag}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        prefix={"€ "}
                                                    />
                                                </td>
                                                <td>€ {row.nieuwbedrag}</td>
                                                <td>
                                                    <div class="btn-group" role="group">
                                                        <a
                                                            id=""
                                                            class="button-modal-table bewerken"
                                                            onClick={() =>
                                                                this.editUit(row.uitvoerder.identification)
                                                            }
                                                        />
                                                        {"\u00A0"}
                                                        <a
                                                            class="button-modal-table delete"
                                                            id=""
                                                            onClick={() =>
                                                                this.remove(row.uitvoerder.identification)
                                                            }
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )):
                                        <tr id={'no-item-row'}>
                                            <td>{'-'}</td>
                                            <td>{'-'}</td>
                                            <td>
                                                {'-'}
                                            </td>
                                            <td>{'-'}</td>
                                            <td>

                                            </td>
                                        </tr>
                                    }
                                    </tbody>
                                </table>

                                <div hidden={!this.state.createState}>
                                    <div className="float-right mt-4">
                                        <a
                                            id="detail-button"
                                            className="back-page-link back-page-link-modal"
                                            role="button"
                                            onClick={this.backTable.bind(this)}
                                        >
                                            <img className="" src={leftPng} width={9} height={12}/>{" "}
                                            &nbsp;Terug naar
                                        </a>
                                    </div>
                                    <br/>
                                    <label>Uitvoerder</label>
                                    <select
                                        class="form-control"
                                        id="maatregelen-kwaliteit"
                                        name="uitvoerder"
                                        value={this.state.uitvoerder}
                                        onChange={this.handleInputChange}
                                    >
                                        {this.state.uitvoerderSelect.map((option) => (
                                            <option
                                                key={option.identification}
                                                value={option.identification}
                                            >
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label>Procentueel</label>
                                    <input
                                        id="maatregelen-code"
                                        type="input"
                                        className="form-control"
                                        name="procentueel"
                                        value={this.state.procentueel}
                                        onChange={this.handleInputChange}
                                        autocomplete="off"
                                    />
                                    <label>Vastbedrag</label>
                                    <input
                                        id="maatregelen-code"
                                        type="input"
                                        className="form-control"
                                        name="vastbedrag"
                                        value={this.state.vastbedrag}
                                        onChange={this.handleInputChange}
                                        autocomplete="off"
                                    />
                                    <label>Nieuwbedrag</label>
                                    <input
                                        id="maatregelen-code"
                                        type="input"
                                        className="form-control"
                                        name="nieuwbedrag"
                                        value={this.state.nieuwbedrag}
                                        onChange={this.handleInputChange}
                                        autocomplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                id="bewerk_prijs_per_uitvoerder_save"
                                className="btn-modal"
                                hidden={!!this.state.createState}
                                onClick={this.handleSubmit.bind(this)}
                            >
                                Verwerken
                            </button>
                            <button
                                type="button"
                                id="bewerk_prijs_per_uitvoerder_save"
                                className="btn-modal"
                                hidden={!this.state.createButtonState}
                                onClick={this.addUit.bind(this)}
                            >
                                toevoegen
                            </button>
                            <button
                                type="button"
                                id="bewerk_prijs_per_uitvoerder_save"
                                className="btn-modal"
                                hidden={!this.state.editButtonState}
                                onClick={this.editUitSave.bind(this)}
                            >
                                bewerk
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Bewerkprijsperuitvoerder;
